export default __webpack_public_path__ + "static/iiot_gateway-29fb01804b992e01b36e233b543ba160.png";